export const baseGameState = {
  username: ' ',
  curLevel: 0,
  score: 0,
  exp: 0,
  lives: 3,
  playerLevel: 0,
  numberOfAsteroids: 0,
  timer: 0,
  paused: 0,
  gameOver: 0,
};
